export default {
  namespaced: true,
  state: () => ({
    selectedProjectType: '',
    selectedDebrisType: [],
    selectedFillType: '',
    zip: ''
  }),
  mutations: {
    selectedProjectType (state, payload) {
      state.selectedProjectType = payload
      // Reset debris and fill types on project change
      state.selectedDebrisType = []
      state.selectedFillType = ''
    },
    selectedDebrisType (state, payload) {
      state.selectedDebrisType = payload
    },
    selectedFillType (state, payload) {
      state.selectedFillType = payload
    }
  },
  getters: {
    selectedFillType (state) {
      // Only return a fill type if the selected debris type was heavy
      return state.selectedDebrisType.includes('heavy') ? state.selectedFillType : ''
    },
    readyForMako (state, getters, rootState) {
      const postalCode = rootState.customer.serviceAddress.postalCode
      const { selectedProjectType, selectedDebrisType, selectedFillType } = state
      const isHeavy = state.selectedDebrisType.includes('heavy')
      const hasAllInfo = postalCode && selectedProjectType && selectedDebrisType.length

      // If heavy is selected along with another type it does not need a filltype
      if (isHeavy && selectedDebrisType.length >= 2 && hasAllInfo) {
        return true
      }

      // Make sure heavy has a fill type
      if (isHeavy && selectedFillType && hasAllInfo) {
        return true
      }

      if (!isHeavy && hasAllInfo) {
        return true
      }

      return false
    }
  }
}
